<div class="container">
    <div class="wrapper">
        <h1 class="pageTitle" id="main-content" >
            {{pageTitle | translate}}</h1>
        <h2 class="govuk-heading-m">{{verifyPageText | translate}}</h2>

    </div>
</div>